'use client';

import * as React from 'react';
import { useAppSelector } from '@/store/hooks';
import { getDrawerContent } from '@/store/reducers/drawer-content-slice';
import { Stack } from '@mui/system';

import { AlienDomain, AlienDomainDns, DataFetchResponse } from '@/types/general';
import { ColumnDef } from '@/components/core/data-table';
import { ReusableTable } from '@/components/core/reusable-table';

export function DNSTab(): React.JSX.Element {
  const { DOMAIN_DETAILS } = useAppSelector(getDrawerContent);
  const initialSearchParams = new URLSearchParams({ page: '1', limit: '50' });

  const fetchDomainData = async (
    searchParams: URLSearchParams
  ): Promise<{ data: AlienDomainDns[]; count: number; remaining: number }> => {
    try {
      const response = await fetch(`/api/devops/domains/list`, {
        method: 'post',
        body: JSON.stringify({ domainName: DOMAIN_DETAILS, searchParams }),
      });
      const result: DataFetchResponse<AlienDomain> = await response.json();
      if (response.ok && result.success) {
        return { data: result.data.cfDnsRecords, count: 0, remaining: 0 };
      }
      return { data: [], count: 0, remaining: 0 };
    } catch (e) {
      return { data: [], count: 0, remaining: 0 };
    }
  };
  const initialData: AlienDomainDns[] = [];
  const columns = [
    {
      field: 'type',
      name: 'Type',
      width: '200px',
    },
    {
      field: 'name',
      name: 'Name',
      width: '200px',
    },
    {
      field: 'content',
      name: 'Content',
      width: '200px',
    },
  ] satisfies ColumnDef<AlienDomainDns>[];

  React.useEffect(() => {
    void fetchDomainData(initialSearchParams);
  }, []);

  return (
    <Stack direction="column">
      <ReusableTable
        columns={columns}
        fetchData={fetchDomainData}
        initialData={initialData}
        initialSearchParams={initialSearchParams}
      />
    </Stack>
  );
}
